
console.log("t-ver 1.05");
function showMoreNewsList(moreBtn, itemList) {
	moreBtn.disabled = true;
	// let formData = new FormData();
	// formData.append("", "");
	let url = moreBtn.getAttribute('href');
	fetch(url)
	.then((response) => {
		return response.text();
	})
	.then((data) => {
		let html = new DOMParser().parseFromString(data, "text/html");
		let items = html.querySelectorAll(".js-newsItem");
		if(items)
		{
			items.forEach((item) => {
				// itemList.insertAdjacentHTML('beforeend', item);				
				itemList.append(item);				
			});
			
			if (window.matchMedia("(min-width: 1200px)").matches) {
				let count = document.querySelectorAll('.news__list li').length / 2;
				itemList.setAttribute('style', `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`);
			} 
		}
		if(html.querySelector(".js-more"))
			moreBtn.setAttribute("href", html.querySelector(".js-more").getAttribute('href'));
		else
			moreBtn.remove();
	});
}

async function showMoreGallery(moreBtn, itemList) {
	moreBtn.disabled = true;
	let url = moreBtn.getAttribute('href');
 	let res = await fetch(url);
	let data = await res.text();
		let html = new DOMParser().parseFromString(data, "text/html");
		let items = html.querySelectorAll(".js-gl.list a");
		if(items)
		{
			items.forEach((item) => {
				itemList.append(item);				
			});			
		}
		if(html.querySelector(".js-more"))
			moreBtn.setAttribute("href", html.querySelector(".js-more").getAttribute('href'));
		else
			moreBtn.remove();
}

function showMoreTeamList(moreBtn, itemList) {
	moreBtn.disabled = true;
	let formData = new FormData();
	// formData.append("", "");
	let url = moreBtn.getAttribute('href');
	fetch(url)
	.then((response) => {
		return response.text();
	})
	.then((data) => {
		let html = new DOMParser().parseFromString(data, "text/html");
		let items = html.querySelectorAll(".js-Item");
		if(items)
		{
			items.forEach((item) => {
				itemList.append(item);				
			});
		}
		if(html.querySelector(".js-item-more"))
			moreBtn.setAttribute("href", html.querySelector(".js-item-more").getAttribute('href'));
		else
			moreBtn.remove();
	});
}

function showMoreFranchiseProjectsList(moreBtn, itemList) {
	moreBtn.disabled = true;
	let formData = new FormData();
	// formData.append("", "");
	let url = moreBtn.getAttribute('href');
	fetch(url)
	.then((response) => {
		return response.text();
	})
	.then((data) => {
		let html = new DOMParser().parseFromString(data, "text/html");
		let items = html.querySelectorAll(".js-Item");
		if(items)
		{
			items.forEach((item) => {
				itemList.append(item);				
			});
		if (window.matchMedia("(min-width: 1200px)").matches) {
			console.log('desktop');
			let count = document.querySelectorAll('.js-list .item').length / 2;
	        itemList.setAttribute('style', `grid-template-columns: repeat(${Math.ceil(count)}, 1fr)`);
		}
		}
		if(html.querySelector(".js-item-more"))
			moreBtn.setAttribute("href", html.querySelector(".js-item-more").getAttribute('href'));
		else
			moreBtn.remove();
	});
}


function showMoreVacancyList(moreBtn, itemList) {
	moreBtn.disabled = true;
	let formData = new FormData();
	// formData.append("", "");
	let url = moreBtn.getAttribute('href');
	fetch(url)
		.then((response) => {
			return response.text();
		})
		.then((data) => {
			let html = new DOMParser().parseFromString(data, "text/html");
			let items = html.querySelectorAll(".js-Item");
			if (items) {
				items.forEach((item) => {
					item.addEventListener('click', function (e) {
						let hideBlock = item.closest('.item').querySelector('.hide');
						e.preventDefault();
						$(hideBlock).slideToggle("slow", function () {
							item.classList.toggle("active");
						});
					});
					itemList.append(item);
				});
			}
			if (html.querySelector(".js-item-more"))
				moreBtn.setAttribute("href", html.querySelector(".js-item-more").getAttribute('href'));
			else
				moreBtn.remove();
		});
}

function showMoreCasesList(moreBtn, itemList) {
	moreBtn.disabled = true;
	let formData = new FormData();
	// formData.append("", "");
	let url = moreBtn.getAttribute('href');
	fetch(url)
		.then((response) => {
			return response.text();
		})
		.then((data) => {
			let html = new DOMParser().parseFromString(data, "text/html");
			let items = html.querySelectorAll(".js-Item");
			if (items) {
				items.forEach((item) => {
					item.addEventListener('click', function (e) {
						let hideBlock = item.closest('.item').querySelector('.hide');
						e.preventDefault();
						$(hideBlock).slideToggle("slow", function () {
							item.classList.toggle("active");
						});
					});
					itemList.append(item);
				});
			}
			if (html.querySelector(".js-more"))
				moreBtn.setAttribute("href", html.querySelector(".js-more").getAttribute('href'));
			else
				moreBtn.remove();
		});
}


// FEEDBACK //
function sendForm(form)
{
	isStartSendForm = true;
	// event.preventDefault();
	let nameAction = form.getAttribute("name");
	let formData = new FormData(form);
	formData.append("check","nospam");
	let paramsAction = {
		mode: 'class',
		data: formData
	}
	BX.ajax.runComponentAction("custom:feedback", "sendForm"+nameAction, paramsAction).then((response) => {
		if(response.status == "success")
		{
			isStartSendForm = false;			
			if(response.data.ERROR){
				console.log("Ошибка на форме");
				toastr.error(`${form.getAttribute('data-error')}`);

				return false;
			}
			console.log(response.data.ID, ' success');
			toastr.success(`${form.getAttribute('data-success')}`);
			form.classList.add('success');
			// form.classList.add('success');
			// if(form.querySelector('#typeForm')) {
			// 	if(form.querySelector('#typeForm').value == 'staticForm'){
			// 		form.querySelector('legend').innerHTML = "Cообщение отправленно";
			// 		form.querySelector('p.input').remove();
			// 		form.querySelector('p.input').remove();
			// 		form.querySelector('.button').remove();
			// 	}
			// }
			// if(form.closest('.form')) {
			// 	form.closest('.form').classList.add('send');
			// }
		}
	});
}